export function sumAllBeforeIndex(array, index) {
    return array.slice(0, index - 1).reduce((acc, val) => acc + val, 0);
}
export function sumAllAfterIndex(array, index) {
    return array.slice(index).reduce((acc, val) => acc + val, 0);
}
//# sourceMappingURL=sumAll.js.map